// utils/api.js
import { isTokenExpired, logout } from './auth';

const API_URL = 'https://lm897u5lhf.execute-api.us-east-2.amazonaws.com/prod/submissions';

/**
 * Fetch all submissions.
 * @returns {Promise<Array>} - An array of submission objects.
 */
export const fetchSubmissions = async () => {
  const idToken = localStorage.getItem('idToken');

  if (!idToken) {
    throw new Error('ID token is missing. Please log in.');
  }
  if (isTokenExpired(idToken)) {
    logout();
    throw new Error('Unauthorized: Token expired');
  }
  try {
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response from API:', errorData);
      throw new Error(errorData.message || 'Failed to fetch submissions');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching submissions:', error);
    throw error;
  }
};

/**
 * Delete a submission by its ID.
 * @param {string} submissionId
 * @returns {Promise<void>}
 */
export const deleteSubmission = async (submissionId) => {
  const idToken = localStorage.getItem('idToken');

  if (!idToken) {
    throw new Error('ID token is missing. Please log in.');
  }
  if (isTokenExpired(idToken)) {
    logout();
    throw new Error('Unauthorized: Token expired');
  }

  try {
    const response = await fetch(`${API_URL}/${submissionId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error deleting submission:', errorData);
      throw new Error(errorData.message || 'Failed to delete submission');
    }

  } catch (error) {
    console.error('Error deleting submission:', error);
    throw error;
  }
};
